import React from "react";
import PropTypes from "prop-types";
import styles from "./NotesModal.module.css";
import { Modal } from "shared/Modal";
import ModalActionBar from "shared/ModalActionBar";
import classNames from "classnames";

/**
 * Interactive component.
 * Modal used for viewing notes info in the Snapshots tab of the Events page.
 */
export function NotesModal({ isOpen, onClose, onClick, note }) {
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="Notes"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <div className={styles.flex}>
            <div>
              <p>File Name</p>
              <p>{note.fileName}</p>
            </div>
            <div>
              <p>Created On</p>
              <p>{`${note.date} ${note.time}`}</p>
            </div>
            <div>
              <p>Notes</p>
              <p>{note.notes}</p>
            </div>
            <ModalActionBar
              children={
                <div className={styles["button-bar"]}>
                  <button
                    type="button"
                    className={classNames(styles.button, styles.viewBtn)}
                    onClick={onClick}
                  >
                    View Full
                  </button>
                  <button
                    type="button"
                    className={styles.button}
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              }
            />
          </div>
        }
      />
    </div>
  );
}

NotesModal.propTypes = {
  /**
   * Boolean to determine if modal is open.
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when the view full button is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Object with the note's info.
   */
  note: PropTypes.shape({
    fileName: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    notes: PropTypes.string,
  }),
};
